import React from "react";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import {Card, CardActionArea} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    card: {
        boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2)",
        borderRadius: theme.spacing(1)
    },
    cardWrapper: {
        display: "flex",
        justifyContent: "center",
        padding: theme.spacing(3)
    }
}));

const CardButton = ({children, onClick, className}) => {
    const classes = useStyles();

    const handleClick = () => {
        onClick();
    };

    return (
        <Card
            className={classes.card}
        >
            <CardActionArea
                className={className ? className : classes.cardWrapper}
                onClick={handleClick}
            >
                {children}
            </CardActionArea>
        </Card>
    );
};

CardButton.propTypes = {
    children: PropTypes.any,
    onClick: PropTypes.func,
    className: PropTypes.any
};

export default CardButton;
